import { GlobalStyle } from './utilities/globalStyles';
import Router from './routes';
import { signInUser, setLoadingState } from 'src/store/User/user.slice';
import { useEffect } from 'react';
import { useAppThunkDispatch } from './store/store';
import { Auth } from 'aws-amplify';

function App(): JSX.Element {
  const dispatch = useAppThunkDispatch();

  const isUserLoggedIn = async () => {
    try {
      await Auth.currentAuthenticatedUser();
      return true;
    } catch {
      return false;
    }
  };

  useEffect(() => {
    const checkUserStatus = async () => {
      const isLoggedIn = await isUserLoggedIn();
      if (isLoggedIn) {
        await dispatch(signInUser({ email: '', password: '', isRetrievingUser: true }));
      }
      dispatch(setLoadingState(false));
    };

    checkUserStatus();
  }, [dispatch]);

  return (
    <>
      <GlobalStyle />
      <Router />
    </>
  );
}

export default App;
